import {LearningChannelType} from '../../../components/profile/LearningChannel';

export class UpdateLearnerProfileMainChannelRequestDto {
    constructor(public mainChannel: LearningChannelType) {
    }
}
